$(document).ready(function () {
  $(".color-tool-tip").click(function (o) {
    $(this).hasClass("hov")
      ? $(".color-tool-tip").removeClass("hov")
      : ($(".color-tool-tip").removeClass("hov"), $(this).addClass("hov")),
      o.preventDefault(),
      o.stopPropagation(),
      console.log("Clikced");
  }),
    $(".click-disable").click(function (o) {
      o.preventDefault(),
        o.stopPropagation(),
        console.log("Clikced"),
        $(this).find(".color-tool-tip").click();
    }),
    $(".color-selection-pi-text").click(function (o) {
      o.preventDefault(),
        o.stopPropagation(),
        $(this).parent(".color-selection__image--top").click();
    }),
    $(".color-selection__image--top").click(function (o) {
      o.preventDefault(), o.stopPropagation();
      var e = $(this).closest(".color-selection__grid-item").data("count");
      $(".color-selection__selection-container").css("display", "none"),
        $(this).closest(".color-selection__grid-item").hasClass("active")
          ? ($(".color-selection__grid-item.active").removeClass("active"),
            $(".color-selection__selection-container").hide(),
            $("body").removeClass("color-choose-active"))
          : ($(".color-selection__grid-item.active").removeClass("active"),
            $(this).closest(".color-selection__grid-item").addClass("active"),
            $(
              ".color-selection__selection-container[data-count=".concat(e, "]")
            ).css("display", "flex"),
            $("body").addClass("color-choose-active"));
    }),
    $(".color-selection__selection-grid-item.clickable").click(function (o) {
      if ($(this).data("disable") == null) {
        var e = $(this).children(".color-selection__image").data("file"),
          i = $(this).children(".color-selection__image").data("name"),
          r = $(this).children(".color-selection__image").data("variant"),
          t = $(this)
            .parent(".color-selection__selection-container")
            .data("count"),
          n = $(".color-selection__grid-item").data("total-count"),
          l = $("#color".concat(t)),
          c = $(
            ".color-selection__grid-item[data-count=".concat(t, "]")
          ).children(".color-selection__image--top");
        $(".color-selection__grid-item[data-count=".concat(t, "]"))
          .children(".color-selection__image--top")
          .find(".color-selection-ad-text")
          .remove(),
          l.val(i),
          l.attr("variant-id", r),
          c.css("backgroundImage", "url(".concat(e, ")")),
          c.css("backgroundColor", "#fff"),
          c.addClass("coladded");
        var a = $('.hidden-color[value!=""]').length,
          s = parseInt($("#pick-color-id").attr("custom-toshow"));
        console.log(s),
          console.log(a),
          a == s && $("#AddToCart").removeAttr("disabled");
        var t = $(this).closest(".color-selection__grid-item").data("count");
        $(".color-selection__selection-container").css("display", "none"),
          $(this).closest(".color-selection__grid-item").hasClass("active")
            ? $(this)
                .closest(".color-selection__grid-item")
                .removeClass("active")
            : ($(this)
                .closest(".color-selection__grid-item")
                .addClass("active"),
              $(
                ".color-selection__selection-container[data-count=".concat(
                  t,
                  "]"
                )
              ).css("display", "flex"));
      } else o.stopPropagation();
    }),
    $("body").click(function (o) {
      !$(o.target).is(".color-selection__image--top") &&
        !$(o.target).is("#MainPaymentContainer .disabled-text") &&
        !$(o.target).is("#MainPaymentContainer #AddToCart") &&
        !$(o.target).is(".color-selection-pi-text") &&
        !$(o.target).is(".color-tool-tip") &&
        ($(".color-selection__grid-item.active").removeClass("active"),
        $(".color-selection__selection-container").hide(),
        $("body").removeClass("color-choose-active"));
    }),
    $("#AddToCart").attr("disabled", "true"),
    $("#AddToCart").append(
      "<span class='disabled-text'>Scegli i tuoi colori</span>"
    ),
    $("#StickyAddToCart .loader-button__text").text("Scegli i tuoi colori"),
    $("#StickyAddToCart").click(function (o) {
      o.preventDefault(),
        o.stopPropagation(),
        o.stopImmediatePropagation(),
        $("html, body").animate(
          {
            scrollTop: $(".product__info form.shopify-product-form").offset()
              .top,
          },
          2e3
        );
    }),
    document.addEventListener("variant:changed", function (o) {
      var e = $('.hidden-color[value!=""]').length,
        i = parseInt($("#pick-color-id").attr("custom-toshow"));
      e == i ||
        setTimeout(function () {
          $("#AddToCart").attr("disabled", "true");
        }, 100);
    }),
    $("body").on("click", "#MainPaymentContainer", function () {
      $(this).find("#AddToCart").attr("disabled") == "disabled" &&
        $(".color-selection__image.color-selection__image--top.pi-1").trigger(
          "click"
        );
    });
});

function generateUID() {
  var firstPart = (Math.random() * 46656) | 0;
  var secondPart = (Math.random() * 46656) | 0;
  firstPart = ("000" + firstPart.toString(36)).slice(-3);
  secondPart = ("000" + secondPart.toString(36)).slice(-3);
  return firstPart + secondPart;
}

async function addRelated(variantIdArray, $that) {
  const set_id = generateUID();

  const reduced_obj = variantIdArray.reduce(function (obj, b) {
    obj[b] = ++obj[b] || 1;
    return obj;
  }, {});


  let child_variant_ids = "";
  Object.keys(reduced_obj).forEach((key, index) => {
    if (index != 0) {
      if (!child_variant_ids.includes(key)) {
        child_variant_ids += key + ":" + reduced_obj[key];
        child_variant_ids += "__";
      }
    }
  });

	const product_data = [];
  Object.keys(reduced_obj).forEach((key, index) => {
    if (index == 0) {
      const props = {};
      $(".hidden-color").each(function (index) {
        const color_string = "Colore " + (index + 1);
        props[color_string] = $(this).val();
      });

      /*
      props["_bundle-parent"] = true;
      props["_set"] = set_id;
      props["_variants_set"] = child_variant_ids;
      */
      
      product_data.push({
        quantity: reduced_obj[key],
        id: parseInt(key),
        properties: props,
      });
    }
    /*else {
      let prod = {};
      prod["quantity"] = reduced_obj[key];
      prod["id"] = parseInt(key);
      prod["properties"] = {
        "_bundled-product": true,
        _set_id: set_id,
      };

      product_data.push(prod);
      console.log(prod);
    }*/
  });

  const data = {
    items: product_data,
    sections: ["mini-cart"],
  };

  const response = await fetch(
    `${window.themeVariables.routes.cartAddUrl}.js`,
    {
      body: JSON.stringify(data),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    }
  );

  const responseJson = await response.json();

  if (response.ok) {
    $that.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: {
          variant: responseJson.hasOwnProperty("items")
            ? responseJson["items"][0]
            : responseJson,
        },
      })
    );
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
        cartContent["sections"] = responseJson["sections"];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart:
                window.themeVariables.settings.cartType === "drawer" &&
                $that.closest(".drawer") === null,
            },
          })
        );
      }
    );
  }

  $that.dispatchEvent(
    new CustomEvent("cart-notification:show", {
      bubbles: true,
      cancelable: true,
      detail: {
        status: response.ok ? "success" : "error",
        error: responseJson["description"] || "",
      },
    })
  );
}

$(document).ready(function () {
  $("#AddToCart").click(async function (e) {
    e.preventDefault();
    e.stopPropagation();

    let items = [];

    $that = this;

    items.push(
      parseInt($('.product-form__buy-buttons input[name="id"]').val())
    );

    $(".hidden-color").each(function (index) {
      items.push(parseInt($(this).attr("variant-id")));
    });

    console.log("items", items);

    addRelated(items, $that);

    console.log(items);
  });
});
